/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs */

const en_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alerts`)
};

const ar_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التنبيهات`)
};

const bn_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সতর্কতা`)
};

const de_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnungen`)
};

const es_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas`)
};

const fr_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes`)
};

const pt_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas`)
};

const zh_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`告警`)
};

const tr_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uyarılar`)
};

const ru_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Алерты`)
};

const pl_svc_ecommerce_amazon_tools_tlm_2 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerty`)
};

/**
* | output |
* | --- |
* | "alerts" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_tlm_2 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_tlm_2(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_tlm_2(inputs)
	return en_svc_ecommerce_amazon_tools_tlm_2(inputs)
});
export { svc_ecommerce_amazon_tools_tlm_2 as "svc_ecommerce-amazon-tools_tlm_2" }